<template>
	<nav class="navbar" :class="[setType,setFixed]">
		<div :class="setContainer">
			<div class="navbar-header" v-if="this.name||this.logo">
				<a class="navbar-brand" href="#">
					<img v-if="!!logo" :alt="name" :src="logo" height="20"> {{!logo?name:''}}
				</a>
			</div>
			<div class="collapse navbar-collapse">
				<slot name="nav"></slot>
				<slot name="form"></slot>
				<slot name="nav-right"></slot>
				<slot></slot>
			</div>
	</nav>
</template>

<script>
	export default {
		props: {
			full: {
				type: Boolean,
				default: true
			},
			inverse: Boolean,
			fixed: String,
			logo: String,
			name: String,
		},
		computed: {
			setContainer() {
				return this.full ? 'container-fluid' : 'container'
			},
			setType(){
				return this.inverse?'navbar-inverse':'navbar-default';
			},
			setFixed() {
				if(this.fixed=="top"){
					return "navbar-fixed-top";				
				}else if(this.fixed=="bottom"){
				return "navbar-fixed-bottom";}
			}
		},
		filters: {

		},
		mounted() {

		}
	}
</script>
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.navbar {
		.unbdr;
		.unbd;
		.bdrb;
		&-right{
			p&{
				.mgb(0);
			}
		}
	}
</style>


// WEBPACK FOOTER //
// navbar.vue?26ec59ea